import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Glyph from "@/bit/components/components.icon-glyph";
import TextInfo from "@/bit/components/components.text";
import dynamic from "next/dynamic";
import { actions as modalActions } from "@/bit/reducers/reducers.modals-reducer";

const CustomLink = dynamic(() =>
  import("@/bit/components/components.custom-link")
);

const LocationText = (props) => {
  const [legalInfo, setLegalInfo] = useState(false);
  const [firstItemLegal, setFirstItemLegal] = useState("");
  const Main = useSelector((state) => state.main);
  const { zone, cpModalClosed, userPq: isBafClient } = Main;
  const [zoneInfo, setZoneInfo] = useState("");
  const dispatch = useDispatch();
  const locationLegal = {
    description: "Titulo de legales",
    kind: "heading",
    level: 3,
    size: "title05",
    color: "blue_dark",
    fontType: "font-regular",
    title: "Condiciones legales",
  };

  const componentName = props["orionInfo"]["Name"];

  const taggingInfoLegalModal = {
    componentName: "LegalConditions",
    componentVariation: "all",
    componentContent: "",
  };

  useEffect(() => {
    if (cpModalClosed && zone !== zoneInfo) {
      setLegalInfo(false);
      setZoneInfo(zone);
    }
  }, [zone, cpModalClosed]);

  const isClientBaf = (keys) => {
    if (Array.isArray(keys) && isBafClient?.ppt && isBafClient?.ppt === 2) {
      keys.splice(1, 1, keys.splice(3, 1)[0]);
    } else {
      keys.pop();
    }
    return keys;
  };

  const handleLegalModal = () => {
    const { orionInfo, productName } = props;
    let modalLegalInfo = { titles: [], titlesLegal: [], desc: [] };
    let concatDesc = "";
    if (orionInfo && Object.keys(orionInfo).length) {
      Object.entries(orionInfo).forEach(([key, value]) => {
        if (zone === "ZR") {
          if (key.indexOf("ZR") != -1) {
            let cardKeys = Object.keys(value).filter((key) =>
              /^Product-\d+$/.test(key)
            );
            cardKeys.map((key) => {
              modalLegalInfo.titlesLegal.push(
                value[key]?.["Legal-1"]?.["Text-1"] ||
                  value[key]?.["FlyOut-1"]?.["TextLegal-1"]
              );

              modalLegalInfo.titles.push(
                `<br/><b>${value[key]?.["Text-1"]?.text}</b><br/>`
              );

              modalLegalInfo.desc.push(
                value[key]?.["Legal-1"]?.["Text-2"] ||
                  value[key]?.["FlyOut-1"]?.["TextLegal-3"]
              );

              if (
                value[key]?.["Legal-1"]?.["Text-2"]?.text ||
                value[key]?.["FlyOut-1"]?.["TextLegal-3"]?.text
              ) {
                // Valida si existe descripción
                if (
                  !concatDesc.includes(value[key]?.["Text-1"]?.text) &&
                  !concatDesc.includes(
                    value[key]?.["Legal-1"]?.["Text-2"]?.text ||
                      value[key]?.["FlyOut-1"]?.["TextLegal-3"]?.text
                  )
                ) {
                  // Validación para que no se repitan legales
                  concatDesc =
                    concatDesc +
                    `<br/><b>${value[key]?.["Text-1"]?.text}</b><br/>${
                      value[key]?.["Legal-1"]?.["Text-2"]?.text ||
                      value[key]?.["FlyOut-1"]?.["TextLegal-3"]?.text
                    }<br/>`;
                }
              }
            });
          }
        }
        if (zone === "ZL") {
          if (key.indexOf("ZL") != -1) {
            let cardKeys = Object.keys(value).filter((key) =>
              /^Product-\d+$/.test(key)
            );
            if (productName === "tarifas-contrato-r" && cardKeys.length > 3) {
              cardKeys = isClientBaf(cardKeys);
            }
            cardKeys.map((key) => {
              modalLegalInfo.titlesLegal.push(
                value[key]?.["Legal-1"]?.["Text-1"] ||
                  value[key]?.["FlyOut-1"]?.["TextLegal-1"]
              );

              modalLegalInfo.titles.push(
                `<br/><b>${value[key]?.["Text-1"]?.text}</b><br/>`
              );

              modalLegalInfo.desc.push(
                value[key]?.["Legal-1"]?.["Text-2"] ||
                  value[key]?.["FlyOut-1"]?.["TextLegal-3"]
              );

              if (
                value[key]?.["Legal-1"]?.["Text-2"]?.text ||
                value[key]?.["FlyOut-1"]?.["TextLegal-3"]?.text
              ) {
                // Valida si existe descripción
                if (
                  !concatDesc.includes(value[key]?.["Text-1"]?.text) &&
                  !concatDesc.includes(
                    value[key]?.["Legal-1"]?.["Text-2"]?.text ||
                      value[key]?.["FlyOut-1"]?.["TextLegal-3"]?.text
                  )
                ) {
                  // Validación para que no se repitan legales
                  concatDesc =
                    concatDesc +
                    `<br/><b>${value[key]?.["Text-1"]?.text}</b><br/>${
                      value[key]?.["Legal-1"]?.["Text-2"]?.text ||
                      value[key]?.["FlyOut-1"]?.["TextLegal-3"]?.text
                    }<br/>`;
                }
              }
            });
          }
        }
      });
      if (legalInfo) {
        modalLegalInfo.desc[0].text = modalLegalInfo.desc[0].text;
      } else {
        if (modalLegalInfo.desc[0].text.length > 1500) {
          modalLegalInfo.desc[0].text =
            firstItemLegal +
            concatDesc.replace(
              modalLegalInfo.titles[0] + modalLegalInfo.desc[0].text,
              ""
            );
        } else {
          setFirstItemLegal(
            modalLegalInfo.titles[0] + modalLegalInfo.desc[0].text
          );
          modalLegalInfo.desc[0].text = concatDesc.slice(5);
        }
      }
      setLegalInfo(true);
    } else {
      modalLegalInfo = locationLegal;
    }

    const LegalModal = dynamic(() => import("@/component/legal-modal"));
    dispatch(
      modalActions.addModal({
        id: "legal-modal",
        Element2Show: LegalModal,
        modalProps: {
          contentPosition: "right--top",
          opacityLayoutColor: "blur",
          inSceneEffect: "fadeIn",
          contentInsideContainer: false,
          outSceneEffect: "fadeOut",
          closeByClickingOutside: true,
          scrollAllowed: false,
          createAnchor: false,
        },
        elementProps: {
          title: modalLegalInfo?.titlesLegal?.[0] || "",
          description: modalLegalInfo?.desc?.[0] || "",
          taggingInfo: taggingInfoLegalModal,
        },
      })
    );
  };

  return (
    <>
      <div className="ubicacion-container container">
        {componentName === "DISTRI_BOX" || (
          <Glyph id="ubicacion-s" width="16px" color="grey6" />
        )}

        <div className="ubicacion-text">
          {componentName === "DISTRI_BOX" || (
            <TextInfo
              text={`Ofertas para el  C.P ${!Main.cp ? "..." : Main.cp}`}
              fontType="font-regular"
              size="subtitle2"
              display="block"
              border="none"
            />
          )}

          <TextInfo
            text="Todos los precios incluyen IVA."
            fontType="font-regular"
            size="subtitle2"
            display="block"
            border="none"
          />
          {/* {componentName === "DISTRI_BOX" || ( */}
          <CustomLink
            title="Ver condiciones legales"
            ariaLabel="Ver condiciones legales"
            onClick={() => handleLegalModal()}
            className="location-link-legal"
            taggingInfo={{
              componentName: "location-text",
              componentContent: "VerCondicionesLegales",
              componentVariation: "all",
              componentPerso: "",
              componentProduct: "",
            }}
          >
            <TextInfo
              text={`Ver condiciones legales`}
              fontType="font-regular"
              size="subtitle2"
              color="blue_a"
              display="block"
              border="none"
            />
          </CustomLink>
        </div>
      </div>
      <style jsx>
        {`
          .ubicacion-container {
            display: flex;
            flex-direction: row;
            margin-bottom: 1.5rem;
            margin-top: 1rem;
            align-items: center;

            @media screen and (max-width: 768px) {
              align-items: flex-start;
            }

            :global(.svg-layout-size) {
              margin-top: 0;

              @media screen and (max-width: 768px) {
                margin-top: 4px;
              }
            }

            .ubicacion-text {
              text-indent: 8px;
              display: flex;

              :global(.text) {
                line-height: 24px;
              }

              @media screen and (max-width: 768px) {
                flex-direction: column;
                text-indent: 0px;
              }

              :global(.location-link-legal) {
                margin-left: 8px;
                @media screen and (max-width: 768px) {
                  margin-left: 0px;
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default LocationText;
